import React, { Component } from 'react';
import _validator from 'modules/validator';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Challan from './Challan';
import NavigationTab from './NavigationTab_new_one';
// Stage 3.5 (Enterprise Candidate Registration Wizard Modernization): the Stage 3.2 shared Card
// wraps this page's outer section only — #divChallanPrint (captured by html2canvas/jspdf in
// onPrint) and its <Challan> children are left completely untouched.
import Card from 'components/enterprise/Card';
// Migrates the bilingual UI chrome OUTSIDE #divChallanPrint (page title, "Challan not set" message,
// Note label, and the 4 action buttons) onto the centralized language-resource Text primitive.
// #divChallanPrint's own <Challan copyName=...> bilingual divs are left completely untouched.
import Text from 'components/Text/Text';

class CandidateChallanDetails_new extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: [],
            posts: [],
            loading: true,
            // Sprint 2.6.2 (Candidate Experience Modernization): tracks the PDF-generation spinner
            // (onPrint) separately from the initial-data-fetch `loading` above.
            isLoadingPdf: false,
            studentPersonalModel: {},
            challanBankDetailModel: {},
            studentReservationModel: {},
        };
    }

    componentDidMount() {
        this.getStudentPersonalData();
    }

    getStudentPersonalData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let response = await _StudentService.getStudentReceiptData();
                    //console.log("Candidate Data: ", response.data);
                    this.setState({
                        data: response.data,
                        studentPersonalModel: response.data.studentPersonalModel,
                        challanBankDetailModel: response.data.challanBankDetailModel,
                        studentReservationModel: response.data.studentReservationModel,
                        loading: false
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onPrint = () => {
        this.setState({ isLoadingPdf: true });

        const originalDiv = document.querySelector("#divChallanPrint");

        // Clone the div to avoid modifying the original
        const clonedDiv = originalDiv.cloneNode(true);
        clonedDiv.style.position = "absolute";
        clonedDiv.style.left = "-9999px"; 
        clonedDiv.style.height = "941.89px"; 
        document.body.appendChild(clonedDiv);

        
        html2canvas(clonedDiv, {
            scale: 3, allowTaint: true, useCORS: true
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.8);

            const doc = new jsPDF({
                orientation: 'l',
                unit: 'pt',
                format: 'a4',
                compressPdf: true
            });

            const pageWidth = 841.89;
            const pageHeight = 595.28;

            const margin = 1; // Margin for all sides
            const contentWidth = pageWidth - margin * 2;
            const contentHeight = pageHeight - margin * 2;

            const widthRatio = contentWidth / canvas.width;
            const heightRatio = contentHeight / canvas.height;
            const ratio = Math.min(widthRatio, heightRatio);

            const canvasWidth = canvas.width * ratio;
            const canvasHeight = canvas.height * ratio;

            // Center the image within the margins
            const xOffset = margin + (contentWidth - canvasWidth) / 2;
            const yOffset = margin;

            doc.addImage(imgData, 'JPEG', xOffset, yOffset, canvasWidth, canvasHeight);
            doc.save("challan.pdf");
            document.body.removeChild(clonedDiv);
            this.setState({ isLoadingPdf: false });
        });


        //console.log('Data URL: ');
    }

    onTabOrderChange = () => {
        this.props.onTabOrderChange(5);
    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    // Sprint 2.6.2 (Candidate Experience Modernization): a real "Previous" step, distinct from Cancel
    // (which still exits to the dashboard) — returns to Preview (tabID 10), the actual predecessor screen
    // in this flow (PreviewCandidateDetails_new.jsx.onTabOrderChange routes here when payment is offline).
    onPrevious = () => {
        this.props.onTabOrderChange(10);
    }

    //const StudentPersonalInfo = () => {
    render() {
        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <>
                <NavigationTab onTabOrderChange={this.onTabOrderChange} currentStep={4} />

                {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim. */}
                <div className="candidate-challan printPage ent-container gl-bxbr  analysisWrap p-4 mt-3">
                    {/* Stage 3.5: fixed <h5 className="ch-heading4"> tag/class mismatch — every other
                        wizard page pairs this class with a real <h4>. */}
                    <Text k="challanDetails.printChallanHeading" tag="h4" className="ch-heading4 mb-3" />
                    <Card>
                    {this.state.challanBankDetailModel ?
                        <div id="divChallanPrint" style={{ display: 'inline-flex' }}>
                            <Challan data={this.state.studentPersonalModel}
                                bankDetails={this.state.challanBankDetailModel}
                                note={this.state.challanBankDetailModel.Note1}
                                reservationDetails={this.state.studentReservationModel}
                                copyName={
                                    <div className='displayInGrid'>
                                        <div>Bank Copy</div>
                                        <div>बँक प्रत</div>
                                    </div>}
                            >

                            </Challan>
                            <Challan data={this.state.studentPersonalModel}
                                bankDetails={this.state.challanBankDetailModel}
                                note={this.state.challanBankDetailModel.Note2}
                                reservationDetails={this.state.studentReservationModel}
                                copyName={
                                    <div className='displayInGrid'>
                                        <div>Office Copy</div>
                                        <div>ऑफिस प्रत</div>
                                    </div>}
                            >

                            </Challan>
                            <Challan data={this.state.studentPersonalModel}
                                bankDetails={this.state.challanBankDetailModel}
                                note={this.state.challanBankDetailModel.Note3}
                                reservationDetails={this.state.studentReservationModel}
                                copyName={
                                    <div className='displayInGrid'>
                                        <div>Applicant Copy</div>
                                        <div>अर्जदाराची प्रत</div>
                                    </div>}
                            >

                            </Challan>

                        </div>
                        : <Text k="challanDetails.challanNotSetError" tag="h5" className="heading mb-4 color-red" />
                    }
                    </Card>
                    {localStorage['ChallanPageNote'] && 
                        <div className="ch-note mt-4">
                            <div className="candidate-container p-4">
                                <Text k="challanDetails.noteLabel" tag="div" className="h5 font-weight-bold" />
                                <div
                                    dangerouslySetInnerHTML={{ __html: localStorage['ChallanPageNote'] }}
                                ></div>
                            </div>
                        </div>
                    }

                    <div className="row mt-4">
                        <div className="col-12">
                        <div className="form-action d-flex justify-content-end button-global-group btn3">
                            <div className="btn2-wrap">
                            <ButtonComponent
                                id="btnCancel"
                                type="button"
                                value={
                                <div className="displayInGrid">
                                    <Text k="challanDetails.cancelButton" />
                                </div>
                                }
                                className="button-global button-border mr-4 autoHeight"
                                onClick={this.onCancel}
                            />
                            <ButtonComponent
                                id="btnPrevious"
                                type="button"
                                value={
                                <div className="displayInGrid">
                                    <Text k="challanDetails.previousButton" />
                                </div>
                                }
                                className="button-global button-border mr-4 autoHeight"
                                onClick={this.onPrevious}
                            />
                            <ButtonComponent
                                id="btnContinue"
                                type="button"
                                value={
                                <div className="displayInGrid">
                                    <Text k="challanDetails.continueButton" />
                                </div>
                                }
                                className="button-global button-primary mr-4 autoHeight"
                                onClick={this.onTabOrderChange}
                            />
                            </div>

                            <ButtonComponent
                            id="btnDownloadChallan"
                            type="button"
                            disabled={this.state.isLoadingPdf}
                            value={
                                <div className="displayInGrid">
                                <Text k={this.state.isLoadingPdf ? "challanDetails.preparingChallan" : "challanDetails.downloadChallanButton"} />
                                </div>
                            }
                            // Stage 3.5: migrated off the buggy, 4-way-duplicated .button-secondary
                            // (see frontendDesign/Stage_3_5/Review/ERPM_S3_5_UI_Review.md) onto
                            // .button-outline — fixes this call site without touching the shared rule.
                            className="button-global button-outline autoHeight"
                            onClick={this.onPrint}
                            />
                        </div>
                        </div>
                    </div>
                    {this.state.isLoadingPdf && <LoadingSpinner />}
                </div>

                
            </>
        )
    };
}

export default CandidateChallanDetails_new;